<template>
    <LayoutSub :className="activeContent === 'intro' ? 'bridging pb-0' : 'bridging'">
        <div class="tab_menu">
            <button @click="changeContent('intro')" :class="activeContent === 'intro' ? 'selected' : ''">소개</button>
            <button @click="changeContent('list')" :class="activeContent === 'list' ? 'selected' : ''">활동내역</button>
        </div>

        <template v-if="activeContent === 'intro'">
            <SubSection class="content pb-0">
                <div class="title_section">
                    <div class="title_wrap">
                        <h2><span class="c-red">사람과 사람을 이어주는 </span> <br />한국정보통신(주) 브리징 봉사단</h2>
                    </div>
                    <p>
                        2007년 설립한 브리징봉사단은 KICC의 비전인 Total Bridging People & Shop 을 계승하여 모든사람들의 행복을 위한 가교 역할을
                        하자는 의미를 가지며 <br />5개의 봉사회로 구성되어 각지의 어려운 이웃을 찾아 사랑을 나누는 사회복지, 자원봉사 활동을 펼치며
                        사회공헌을 실천하는 기업시민으로서의 역할을 수행하고 있습니다.
                    </p>
                    <div class="bridging_logo_wrap">
                        <div class="bridging_logo">
                            <img src="@/assets/bridging_logo1.png" alt="" />
                        </div>
                        <div class="bridging_logo">
                            <img src="@/assets/bridging_logo2.png" alt="" />
                        </div>
                        <div class="bridging_logo">
                            <img src="@/assets/bridging_logo3.png" alt="" />
                        </div>
                        <div class="bridging_logo">
                            <img src="@/assets/bridging_logo4.png" alt="" />
                        </div>
                        <div class="bridging_logo">
                            <img src="@/assets/bridging_logo5.png" alt="" />
                        </div>
                    </div>
                </div>
            </SubSection>
            <SubSection type="wide" class="history_section">
                <div class="inner">
                    <div class="left_title_area">
                        <h3>역사</h3>
                    </div>
                    <div class="right_content_area">
                        <div class="content">
                            <div
                                class="content_row"
                                v-for="(year, idx) in Object.keys(this.historyData).sort((a, b) => b - a)"
                                :key="year"
                                :class="{ fold: activeRows.includes(idx) }"
                            >
                                <div class="row_title" @click="toggleActive(idx)">
                                    <span>{{ year }}</span>
                                </div>
                                <div class="row_content">
                                    <ul>
                                        <li
                                            v-for="month in Object.keys(this.historyData[year]).sort((a, b) => {
                                                if (a === '01~12') return 1;
                                                if (b === '01~12') return -1;
                                                return +b - +a;
                                            })"
                                            :key="`${year}_${month}`"
                                        >
                                            <span class="row_content_title">{{ month }}</span>
                                            <div class="row_content_list">
                                                <p
                                                    class="row_content_text"
                                                    v-for="(content, idx) in this.historyData[year][month]"
                                                    :key="`${year}_${month}_${idx}`"
                                                >
                                                    {{ content }}
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <button @click="toggleActive(idx)">
                                    <img src="@/assets/history_dropdown.png" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </SubSection>
        </template>

        <SubSection class="content" v-else>
            <ListThumbnailPage :data="data" v-if="data" />
            <LoadingWrap v-else />
        </SubSection>
    </LayoutSub>
</template>
<script>
import LayoutSub from '@/layouts/LayoutSub.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';
import { getBridgingActivity, getBridgingIntroduce } from '@/api';
import ListThumbnailPage from '../../common/ListThumbnailPage.vue';
import SubSection from '@/components/SubSection.vue';

export default {
    components: {
        LayoutSub,
        ListThumbnailPage,
        LoadingWrap,
        SubSection,
    },
    data() {
        const activeRows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
        return {
            activeContent: 'list',
            activeRows,
            data: null,
            history_data: [],
        };
    },
    methods: {
        toggleActive(idx) {
            if (this.activeRows.includes(idx)) {
                this.activeRows = this.activeRows.filter((i) => i !== idx);
            } else {
                this.activeRows.push(idx);
            }
        },
        changeContent(content) {
            this.activeContent = content;
        },
        async getList() {
            try {
                const { paging: data } = await getBridgingActivity(this.$route.query);

                this.data = data;
            } catch (err) {
                if (!this.data) this.data = null;
            }
        },
        async getBridgingIntroduce() {
            this.historyData = {};
            try {
                const response = await getBridgingIntroduce(this.$route.query);

                this.historyData = response.list.reduce((acc, item) => {
                    if (!acc[item.year]) {
                        acc[item.year] = {};
                    }
                    if (!acc[item.year][item.month]) {
                        acc[item.year][item.month] = [];
                    }
                    const splitContents = item.contents.split('|').map((content) => content.trim());
                    acc[item.year][item.month].push(...splitContents);
                    return acc;
                }, {});
            } catch (err) {
                this.historyData = {};
            }
        },
    },
    watch: {
        async $route() {
            await this.getList();
            await this.getBridgingIntroduce();
        },
    },
    async mounted() {
        await this.getList();
        await this.getBridgingIntroduce();

        document.querySelectorAll('.history_section .row_content').forEach((el) => {
            el.style.maxHeight = `${el.scrollHeight}px`;
        });
        this.getList();
    },
};
</script>
